import type { AnalyticsGraphToolChartData } from "@/queries/analytics-custom-charts-types";

interface AnalyticsGraphChartDataBlock {
  charts?: AnalyticsGraphToolChartData[];
  [key: string]: unknown;
}

interface AnalyticsGraphToolOutput {
  chart_data?: AnalyticsGraphChartDataBlock;
  [key: string]: unknown;
}

const parseToolOutputRecord = (output: unknown): AnalyticsGraphToolOutput => {
  if (typeof output === "string") {
    try {
      const parsed = JSON.parse(output) as unknown;
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? (parsed as AnalyticsGraphToolOutput)
        : {};
    } catch {
      return {};
    }
  }

  if (output && typeof output === "object" && !Array.isArray(output)) {
    return output as AnalyticsGraphToolOutput;
  }

  return {};
};

const isSameChartDataEntry = (
  current: AnalyticsGraphToolChartData,
  next: AnalyticsGraphToolChartData,
) => current.chartId === next.chartId && current.selectedViewId === next.selectedViewId;

export const mergeAnalyticsGraphChartDataIntoToolOutput = (
  output: unknown,
  chartData: AnalyticsGraphToolChartData,
): AnalyticsGraphToolOutput => {
  const baseOutput = parseToolOutputRecord(output);
  const existingChartData =
    baseOutput.chart_data && typeof baseOutput.chart_data === "object" ? baseOutput.chart_data : {};
  const existingCharts = Array.isArray(existingChartData.charts) ? existingChartData.charts : [];
  const nextCharts = [
    ...existingCharts.filter(current => !isSameChartDataEntry(current, chartData)),
    chartData,
  ];

  return {
    ...baseOutput,
    chart_data: {
      ...existingChartData,
      charts: nextCharts,
    },
  };
};
